import React from 'react';
import { Home, Users, Plus, MessageCircle, User } from 'lucide-react';

const BottomNav = ({ navigate, currentPage, unreadChatCount }) => {
    // If currently inside an active 1-on-1 chat, hide the bottom bar to maximize screen estate for conversation
    if (currentPage === 'chat') return null;

    const navItems = [
        { key: 'home', label: 'Feed', icon: Home, page: 'home' },
        { key: 'friends', label: 'Friends', icon: Users, page: 'friends' },
        { key: 'create', label: 'Post', icon: Plus, page: 'create', isAction: true },
        { key: 'chats', label: 'Messages', icon: MessageCircle, page: 'chats', badge: unreadChatCount },
        { key: 'profile', label: 'Profile', icon: User, page: 'my-profile' }
    ];

    return (
        <nav className="fixed bottom-2.5 sm:bottom-4 left-1/2 -translate-x-1/2 w-[94%] max-w-lg z-40 select-none">
            <div className="bg-white/90 dark:bg-[#111827]/90 backdrop-blur-xl border border-slate-200/90 dark:border-slate-800/90 rounded-2xl sm:rounded-3xl p-1.5 sm:p-2 shadow-lg shadow-black/5 dark:shadow-black/40 flex items-center justify-between">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = currentPage === item.key || (item.key === 'profile' && currentPage === 'my-profile');

                    if (item.isAction) {
                        return (
                            <div key={item.key} className="flex-1 flex justify-center -mt-5 sm:-mt-6">
                                <button
                                    onClick={() => navigate(item.page)}
                                    title="Create Fleeting Thought"
                                    className="w-11 h-11 sm:w-12 sm:h-12 rounded-2xl bg-gradient-to-tr from-sky-500 to-indigo-600 text-white flex items-center justify-center shadow-md shadow-sky-500/30 hover:shadow-sky-500/50 hover:scale-105 active:scale-95 transition-all duration-150"
                                >
                                    <Plus className="w-5 h-5 sm:w-6 sm:h-6 stroke-[2.5]" />
                                </button>
                            </div>
                        );
                    }

                    return (
                        <button
                            key={item.key}
                            onClick={() => navigate(item.page)}
                            className={`flex-1 flex flex-col items-center py-1 sm:py-1.5 relative transition-all duration-150 rounded-xl sm:rounded-2xl ${
                                isActive
                                    ? 'text-sky-500 dark:text-sky-400 font-bold bg-sky-500/10 dark:bg-sky-500/15'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'
                            }`}
                        >
                            <div className="relative">
                                <Icon className={`w-4.5 h-4.5 sm:w-5 sm:h-5 ${isActive ? 'stroke-[2.5]' : 'stroke-[2]'}`} />
                                {item.badge > 0 && (
                                    <span className="absolute -top-1 -right-2 min-w-[14px] h-[14px] px-0.5 bg-rose-500 text-white font-bold text-[9px] flex items-center justify-center rounded-full shadow-sm">
                                        {item.badge > 9 ? '9+' : item.badge}
                                    </span>
                                )}
                            </div>
                            <span className="text-[10px] sm:text-[11px] font-semibold mt-0.5 tracking-tight">
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
